import { common } from './danfoss/common.js';
import { black } from './danfoss/black.js';
import { grey } from './danfoss/grey.js';
import { red } from './danfoss/red.js';
import { deepRed } from './danfoss/deepRed.js';
import { yellow } from './danfoss/yellow.js';
import { amber } from './danfoss/amber.js';
import { green } from './danfoss/green.js';
import { turquoise } from './danfoss/turquoise.js';
import { blue } from './danfoss/blue.js';
import { darkBlue } from './danfoss/darkBlue.js';
import { deepBlue } from './danfoss/deepBlue.js';
import { magenta } from './danfoss/magenta.js';
import { purple } from './danfoss/purple.js';
import { blueGrey } from './danfoss/blueGrey.js';
import { divergingColors } from './danfoss/divergingColors.js';
import { dataVisualization } from './danfoss/dataVisualization.js';

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	common: common,
	black: black,
	grey: grey,
	red: red,
	deepRed: deepRed,
	yellow: yellow,
	amber: amber,
	green: green,
	turquoise: turquoise,
	blue: blue,
	darkBlue: darkBlue,
	deepBlue: deepBlue,
	magenta: magenta,
	purple: purple,
	blueGrey: blueGrey,
	divergingColors: divergingColors,
	dataVisualization: dataVisualization
});

export { index as i };
